import React from "react";
import { HiOutlineUpload, HiOutlineDownload } from "react-icons/hi";

const Documentos = () => {
  return (
    <div className="row">
      <div className="col-11 d-flex flex-row-reverse">
        <td>
          <button className="btn btn-primary d-flex align-items-center">
            <HiOutlineUpload style={{ marginRight: "6px" }} /> Cargar archivo
          </button>
        </td>
      </div>
      <div className="col-12">
        <table className="table table_headers">
          <thead>
            <tr>
              <th scope="col">Nombre del archivo</th>
              <th scope="col">Creación</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ paddingTop: "14px" }}>BL.pdf</td>
              <td style={{ paddingTop: "14px" }}>Mier 1 Marzo, 2023</td>
              <td>
                <button className="btn btn-primary">Ver</button> <button className="btn btn-secondary"><HiOutlineDownload style={{ marginRight: "6px" }} />Descargar</button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td style={{ paddingTop: "14px" }}>EIR.pdf</td>
              <td style={{ paddingTop: "14px" }}>Lun 6 Marzo, 2023</td>
              <td>
              <button className="btn btn-primary">Ver</button> <button className="btn btn-secondary"><HiOutlineDownload style={{ marginRight: "6px" }} />Descargar</button>
              </td>
            </tr>
          </tbody>
          <tbody>
            <tr>
              <td style={{ paddingTop: "14px" }}>Corte de demoras.pdf</td>
              <td style={{ paddingTop: "14px" }}>Mar 7 Marzo, 2023</td>
              <td>
              <button className="btn btn-primary">Ver</button> <button className="btn btn-secondary"><HiOutlineDownload style={{ marginRight: "6px" }} />Descargar</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="col-12 d-flex justify-content-center paginationList">
          <nav aria-label="Page navigation example">
            <ul className="pagination">
              <li className="page-item">
                <a className="page-link" href="#">
                  Prev
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  1
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  2
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  3
                </a>
              </li>
              <li className="page-item">
                <a className="page-link" href="#">
                  Sig
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Documentos;
